// What a reopened analysis says about how it was financed.
//
// The page seeds its financing toggles once, at mount. Opened by URL with no working state
// (a new tab, another device, a pasted link) the document is not there yet, so the seed was
// cash/cash and defaults, and the fetch that followed set the analysis without ever
// re-seeding. The screen then showed the profit of "purchase financed, rehab cash" next to
// two cash toggles, and the next recalculation sent cash/cash — the mix "reverted".
//
// The pair comes from flip_analysis.financing_structure: that is the pair the engine priced
// those numbers with. `assumptions` is second choice — it held the confirmation screen's
// single mode for both legs until the backend started writing the pair back. The terms
// (LTV, rate, points, fees) come from `assumptions` and only when present, so a missing
// term never overwrites a live value with undefined; an explicit 0 is a value and is kept.

const TERMS = [
  ['purchase_ltv', 'purchaseLTV'],
  ['purchase_interest_rate', 'purchaseInterestRate'],
  ['purchase_loan_points', 'purchaseLoanPoints'],
  ['purchase_lender_fees', 'purchaseLenderFees'],
  ['rehab_financed_pct', 'rehabFinancedPct'],
  ['rehab_interest_rate', 'rehabInterestRate'],
  ['rehab_loan_points', 'rehabLoanPoints'],
];

const mode = (v) => (v === 'financed' ? 'financed' : 'cash');

export function financingSeedFromAnalysis(doc) {
  const fs = doc?.flip_analysis?.financing_structure || {};
  const a = doc?.assumptions || {};
  const purchaseFinancing = mode(fs.purchase ?? a.purchase_financing);
  const rehabFinancing = mode(fs.rehab ?? a.rehab_financing);
  const assumptions = { purchaseFinancing, rehabFinancing };
  for (const [from, to] of TERMS) {
    if (a[from] !== undefined && a[from] !== null) assumptions[to] = a[from];
  }
  // A pair that differs was chosen by someone; the purchase toggle must not inherit over it.
  return { assumptions, rehabFinancingTouched: purchaseFinancing !== rehabFinancing };
}
